import { TActions } from '../../../AppModulesWrapper';

import { IExperiments } from '../../types/reducers/experiments';
import { APPEND_EXPERIMENT } from '../../actions/experiments';
import { servicesCardsTextsExperimentGroups, servicesCardsTextsExperimentName } from '../../constants/experiments';
import {
  servicesVerticalCardsExperimentGroups,
  servicesVerticalCardsExperimentName,
} from '../../constants/experiments/servicesCardsVerticalDesignExperiment';

const defaultState = {
  [servicesCardsTextsExperimentName]: servicesCardsTextsExperimentGroups.default,
  [servicesVerticalCardsExperimentName]: servicesVerticalCardsExperimentGroups.control,
};

export const experiments = (state: IExperiments = defaultState, action: TActions): IExperiments => {
  switch (action.type) {
    case APPEND_EXPERIMENT:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};
